module.exports = __webpack_public_path__ + "static/media/Manikandan Kandadai Venkatesh.f9a01b02.png";